export const gallery = [
  {
    id: 1,
    src: "https://images.unsplash.com/photo-1590076215667-875d4ef2d7de?q=80&w=900&auto=format&fit=crop",
    caption: "Masjid mitra Gerakan Eco Masjid",
    category: "Eco Masjid",
    tall: true,
  },
  {
    id: 2,
    src: "https://images.unsplash.com/photo-1636202339022-7d67f7447e3a?q=80&w=900&auto=format&fit=crop",
    caption: "Kelas literasi bersama siswa sekolah mitra",
    category: "Pendidikan",
    tall: false,
  },
  {
    id: 3,
    src: "https://images.unsplash.com/photo-1593113598332-cd288d649433?q=80&w=900&auto=format&fit=crop",
    caption: "Gotong royong bersama warga",
    category: "Sosial",
    tall: false,
  },
  {
    id: 4,
    src: "https://images.unsplash.com/photo-1604187351574-c75ca79f5807?q=80&w=900&auto=format&fit=crop",
    caption: "Pemilahan sampah program Sedekah Sampah",
    category: "Lingkungan",
    tall: true,
  },
  {
    id: 5,
    src: "https://images.unsplash.com/photo-1542816417-0983c9c9ad53?q=80&w=900&auto=format&fit=crop",
    caption: "Pembinaan tahsin santri TPQ",
    category: "Keagamaan",
    tall: false,
  },
  {
    id: 6,
    src: "https://images.unsplash.com/photo-1558005530-a7958896ec60?q=80&w=900&auto=format&fit=crop",
    caption: "Suasana hijau Kelurahan Kedungwuni Barat",
    category: "Lokasi",
    tall: true,
  },
];
